import { liveEvents } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function LiveEventsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                赛事直播
                <span className="inline-flex items-center ml-3 px-2.5 py-0.5 bg-red-500 text-background-50 rounded-full text-xs font-medium animate-pulse">
                  <span className="w-1.5 h-1.5 bg-background-50 rounded-full mr-1.5"></span>
                  LIVE
                </span>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">高清无延迟，多路信号随心切换</p>
            </div>
            <Link
              to="/category/football"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            >
              更多赛事 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {liveEvents.map((event) => (
              <div
                key={event.id}
                className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full">{event.league}</span>
                  {event.status === 'live' ? (
                    <span className="text-xs font-semibold text-red-500 flex items-center gap-1">
                      <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>直播中 {event.time}
                    </span>
                  ) : event.status === 'upcoming' ? (
                    <span className="text-xs font-medium text-accent-600">{event.startTime}</span>
                  ) : (
                    <span className="text-xs font-medium text-foreground-500">{event.startTime}</span>
                  )}
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{event.title}</h3>
                <p className="text-sm text-foreground-600 mb-4">{event.subtitle}</p>
                {'score' in event && event.status === 'live' && (
                  <div className="flex items-center justify-center gap-6 py-3 bg-background-100 rounded-lg mb-3">
                    <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{event.score.home}</span>
                    <span className="text-sm text-foreground-400">VS</span>
                    <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{event.score.away}</span>
                  </div>
                )}
                {event.status === 'upcoming' && (
                  <div className="flex items-center justify-center gap-6 py-3 bg-background-100 rounded-lg mb-3">
                    <span className="text-sm text-foreground-500">即将开始</span>
                  </div>
                )}
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{(event.viewers / 10000).toFixed(0)}万观看</span>
                  <span className="text-accent-500 font-medium cursor-pointer hover:text-accent-600">进入直播间 <i className="ri-arrow-right-s-line"></i></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}